<template>
	<!-- 请假 -->
	<div class="qingjiaBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">请假</p>
				</div>
			</div>
		</van-sticky>
		<!-- 筛选框 -->
		<div class="selectBoxtab">
			<div>
				<div class="rightSelect">
					<p v-model="firstselectValue">{{firstselectValue}}</p>
					<img src="../assets/img/selectArr.png" alt="" @click="firstSelectBox">
				</div>
				<ul class="selectItem" v-show="firstSelect">
					<li v-for="(selectItem,index) in firstSelectLists" :key="index" @click="firstselectItemFn(selectItem,index)"
					 :class="firstselectIndex == index ? 'active_color' : '' ">
						<img src="../assets/img/all_active.png" alt="" v-show="firstselectIndex == 0 && index == 0 ? true : false" />
						<img src="../assets/img/all.png" alt="" v-show="firstselectIndex != 0 && index == 0 ? true : false" />
						<img src="../assets/img/yunicon.png" alt="" v-show="index == 1 && firstselectIndex != 1  ? true : false">
						<img src="../assets/img/yunicon.png" alt="" v-show="index == 2 && firstselectIndex != 2  ? true : false">
						<img src="../assets/img/yunicon.png" alt="" v-show="index == 3 && firstselectIndex != 3  ? true : false">
						<img src="../assets/img/yunicon_active.png" alt="" v-show="index == firstselectIndex && firstselectIndex != 0  ? true : false">
						<span>{{selectItem}}</span>
						<img class="queryIcon" src="../assets/img/query.png" alt="" v-show="firstselectIndex == index ? true : false">
					</li>
				</ul>
			</div>
			<div>
				<div class="rightSelect">
					<p v-model="secondselectValue">{{secondselectValue}}</p>
					<img src="../assets/img/selectArr.png" alt="" @click="secondSelectBox">
				</div>
				<ul class="selectItem" v-show="secondSelect">
					<li v-for="(selectItem,index) in secondSelectLists" :key="index" @click="secondselectItemFn(selectItem,index)"
					 :class="selectIndex == index ? 'active_color' : '' ">
						<img src="../assets/img/bookicon_active.png" alt="" v-show="index == 0 && selectIndex == 0  ? true : false" />
						<img src="../assets/img/bookicon.png" alt="" v-show="index == 0 && selectIndex != 0  ? true : false" />
						<img src="../assets/img/listicon.png" alt="" v-show="selectIndex != 1 && index == 1 ? true : false" />
						<img src="../assets/img/listIcon_active.png" alt="" v-show="selectIndex == 1 && index == 1 ? true : false" />
						<span>{{selectItem}}</span>
						<img class="queryIcon" src="../assets/img/query.png" alt="" v-show="selectIndex == index ? true : false">
					</li>
				</ul>
			</div>
		</div>
		<!-- 列表 -->
		<!-- <div v-for="(item,index) in getUpdateBooks">
			<div class="biaoqianTitle">
				<h4>{{item.series_name}}</h4>
				<img src="../assets/img/rightarr_pink.png" alt="">
			</div>
			<div class="checkedBooklist">
				<div class="checkedBook" v-for="(item,index) in checkedBooklist" :key="index">
					<div class="bookNameImg">
						<img :src="item.imgUrl" alt="">
						<div class="input_check">
							<input type="checkbox" value="1" :checked="checked" :class="checkedIndex == item.id ? 'active' : ''" @change="checkValue(item.id)" />
							<img class="icon" src="../assets/img/checkedimg.png" alt="" v-show="checkedIndex == item.id ? true : false">
						</div>
					</div>
					<p>{{item.name}}</p>
				</div>
			</div>
		</div> -->
		<!-- -----ooooooooo---- -->
		<div class="soltPhItemBox" v-for="(item,index) in getUpdateBooks" :key="index" v-if="selectIndex == 0 && firstselectValue == item.series_name ? true :false">
			<div class="yunjin_jbBox">
				<div class="limiteFooter">
					<p class="btnLimite">{{item.series_name}}</p>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(itm,ind) in item.book_list">
							<div class="checkedBook">
								<div class="bookNameImg">
									<img :src="$api.$BASE_URL_img + itm.cover_image" alt="">
									<div class="input_check">
										<van-checkbox checked-color="#ff4081" v-model="itm.selected" @click="checkValue(itm.id,itm.name,itm.selected,itm.vip_status)"></van-checkbox>
										<img class="icon" src="../assets/img/checkedimg.png" alt="" v-show="checkedIndex == item.id ? true : false">
									</div>
								</div>
								<p v-if="itm.name.length <= 8">{{itm.name}}</p>
								<p v-if="itm.name.length > 8"><span v-for="(i,idx) in itm.name" v-if="idx<=6">{{i}}</span></p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<div class="soltPhItemBox" v-for="(item,index) in getUpdateBooks" :key="index" v-if="selectIndex == 0 && firstselectValue == '全部'? true :false">
			<div class="yunjin_jbBox">
				<div class="limiteFooter">
					<p class="btnLimite">{{item.series_name}}</p>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(itm,ind) in item.book_list">
							<div class="checkedBook">
								<div class="bookNameImg">
									<img :src="$api.$BASE_URL_img + itm.cover_image" alt="">
									<div class="input_check" v-if="itm.is_leave == 0">
										<van-checkbox checked-color="#ff4081" v-model="itm.selected" @click="checkValue(itm.id,itm.name,itm.selected,itm.vip_status)"></van-checkbox>
										<img class="icon" src="../assets/img/checkedimg.png" alt="" v-show="checkedIndex == item.id ? true : false">
									</div>
									<div class="input_check" v-if="itm.is_leave == 1">
										<van-checkbox disabled v-model="itm.selected" @click="checkValueDisableFn(itm.id,itm.selected)"></van-checkbox>
										<img class="icon" src="../assets/img/checkedimg.png" alt="" v-show="checkedIndex == item.id ? true : false">
									</div>
								</div>
								<p v-if="itm.name.length <= 8">{{itm.name}}</p>
								<p v-if="itm.name.length > 8"><span v-for="(i,idx) in itm.name" v-if="idx<=6">{{i}}</span></p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 列表模式 -->
		<div class="blockBox" v-for="(itm,index) in getUpdateBooks" :key="index" v-if="selectIndex == 1 && firstselectValue == itm.series_name? true :false">
			<div class="biaoqianTitle">
				<h4>{{itm.series_name}}</h4>
			</div>
			<div class="blockLeft" v-for="(item,index) in itm.book_list" :key="index">
				<div class="book_Img">
					<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" />
					<div class="input_check" v-if="item.is_leave == 0">
						<van-checkbox checked-color="#ff4081" v-model="itm.selected" @click="checkValue(itm.id,itm.name,item.selected,item.vip_status)"></van-checkbox>
						<img class="icon" src="../assets/img/checkedimg.png" alt="" v-show="checkedIndex == item.id ? true : false">
					</div>
					<div class="input_check" v-if="item.is_leave == 1">
						<van-checkbox disabled v-model="item.selected" @click="checkValueDisableFn(item.id,item.selected)"></van-checkbox>
						<img class="icon" src="../assets/img/checkedimg.png" alt="" v-show="checkedIndex == item.id ? true : false">
					</div>
				</div>
				<div class="blockBookInfo">
					<div class="bookName">
						<span class="bookTxtBox"><span :style="{width:(item.name.length * 1 ) + 'em' }">{{item.name}}</span></span>  
					</div>
					<div class="auther"><span>{{item.author}}</span><p><span>{{item.total_words}}字</span><span class="wanjie">{{item.progress_status}}</span></p></div>
					<p class="bookType">{{item.original_name + '-' + item.appetency_name + '-' + item.epoch_name + '-' + item.type_name}}</p>
					<div class="introduction">
						<p>{{item.introduce}}</p>
					</div>
					<div class="book_button">
						<button v-for="itemName in item.lable">{{itemName.name}}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="blockBox" v-for="(itm,index) in getUpdateBooks" :key="index" v-if="selectIndex == 1 && firstselectValue == '全部'? true :false">
			<div class="biaoqianTitle">
				<h4>{{itm.series_name}}</h4>
			</div>
			<div class="blockLeft" v-for="(item,index) in itm.book_list" :key="index">
				<div class="book_Img">
					<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" />
					<div class="input_check" v-if="item.is_leave == 0">
						<van-checkbox checked-color="#ff4081" v-model="itm.selected" @click="checkValue(item.id,item.name,item.selected,item.vip_status)"></van-checkbox>
						<img class="icon" src="../assets/img/checkedimg.png" alt="" v-show="checkedIndex == item.id ? true : false">
					</div>
					<div class="input_check" v-if="item.is_leave == 1">
						<van-checkbox disabled v-model="item.selected" @click="checkValueDisableFn(item.id,item.selected)"></van-checkbox>
						<img class="icon" src="../assets/img/checkedimg.png" alt="" v-show="checkedIndex == item.id ? true : false">
					</div>
				</div>
				<div class="blockBookInfo">
					<div class="bookName"><span class="bookTxtBox"><span :style="{width:(item.name.length * 1 ) + 'em' }">{{item.name}}</span></span></div>
					<div class="auther"><span>{{item.author}}</span><p><span>{{item.total_words}}字</span><span class="wanjie">{{item.progress_status}}</span></p></div>
					<p class="bookType">{{item.original_name + '-' + item.appetency_name + '-' + item.epoch_name + '-' + item.type_name}}</p>
					<div class="introduction">
						<p>{{item.introduce}}</p>
					</div>
					<div class="book_button">
						<button v-for="itemName in item.lable">{{itemName.name}}</button>
					</div>
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<div class="footer">
			<button v-for="(item,index) in btn" :key="index" :class="btnindex == index ? 'active' : ''" @click="btnFn(index)">{{item}}</button>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				btnindex: 1, //按钮选中索引
				checkedIndex: '', //选中索引
				checked: false, //复选框是否选中
				firstselectValue: '全部', //筛选框默认选中
				secondselectValue: '封面模式', //筛选框默认选中
				firstselectIndex: 0, //选中索引
				selectIndex: 0, //选中索引
				firstSelect: false, //控制显示隐藏
				secondSelect: false, //控制显示隐藏
				firstSelectLists: ["全部"],
				secondSelectLists: ["封面模式", "列表模式"],
				checkedBooklist: [],
				btn: ["取消", "确认请假"],
				getUpdateBooks: [],
				jb_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				scRadio: '',
				checkListBook: '', //选中书本
				bookName:'',//选中书本mingcheng
				vip_status: '',
			}
		},
		created() {
			// this.ask_leave();//请假
			this.get_update_books();
			// 电量条
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {
			firstSelectBox() { //下拉框选项 显示 -- 1
				this.firstSelect = !this.firstSelect
			},
			secondSelectBox() { //下拉框选项 显示 -- 2
				this.secondSelect = !this.secondSelect
			},
			firstselectItemFn(value, index) { //下拉框选择 -- 1
				this.firstselectValue = value;
				this.firstselectIndex = index;
				this.firstSelect = !this.firstSelect;
			},
			secondselectItemFn(value, index) { //下拉框选择 -- 2
				this.secondselectValue = value;
				this.selectIndex = index;
				this.secondSelect = !this.secondSelect;
			},
			checkValue(id,nameTxt, check,vip_status) {
				this.checkListBook = id;
				this.bookName = nameTxt;
				this.vip_status = vip_status;
				console.log(this.checkListBook,this.bookName)
				// this.$router.push({
				// 	path: '/queryQingjia',
				// 	query: {
				// 		book_id: this.checkListBook
				// 	}
				// })
				if(vip_status == 0){
					Toast('该书本没有V章,不能请假')
					return false;
				}
			},
			checkValueDisableFn() {
				Toast('已申请请假')
			},
			btnFn(index) {
				this.btnindex = index;
				console.log(index)
				if (index == 1 && this.vip_status != 0) {
					this.$router.push({
						path: '/queryQingjia',
						query: {
							book_id: this.checkListBook,
							bookName: this.bookName,
						}
					})
				}
			},
			back() {
				this.$router.push('/updataoldtext')
			},
			get_update_books() {
				this.$axios.post(this.$api.get_update_books).then(res => {
					this.getUpdateBooks = res.data.data;
					// 
					Object.getOwnPropertyNames(this.getUpdateBooks).forEach(key => {
						if (this.getUpdateBooks[key].series_name != undefined) {
							this.firstSelectLists.push(this.getUpdateBooks[key].series_name)
						}
					})
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.qingjiaBox {
		height: 100vh;
	}

	// 头部
	.headerBox {
		height: 160px;
		background-color: #ff4081;
		display: flex;
		background: url(../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;
		.headerQuery {
			margin-top: 80px;
			padding: 0 16px;
			position: relative;
			display: flex;
			width: 100%;
			height: 80px;
			line-height: 80px;
			color: #000;

			.arrImg {
				img {
					width: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 0px;
				}
			}

			.header_titile {
				flex: 1;
				text-align: center;
				font-size: 34px;
				/*px*/
			}
		}

	}

	.selectBoxtab {
		background-color: #fff;
		height: 100px;
		margin-bottom: 10px;

		div {
			// width: 200px;
			float: left;
			position: relative;
			padding: 20px 16px;
			margin-right: 10px;

			.rightSelect {
				background-color: #fff;
				border: 0;
				padding: 10px 20px;
				font-size: left;
				border-radius: 5px;
				border: 1px solid #ff4081;
				/*no*/
				position: relative;

				p {
					display: inline-block;
					color: #ff4081;
					padding-right: 20px;
				}

				img {
					margin-left: 10px;
					vertical-align: middle;
					width: 20px;
					position: absolute;
					top: 50%;
					right: 10px;
					transform: translateY(-50%);
				}
			}

			.selectItem {
				position: absolute;
				top: 80px;
				left: 20px;
				background-color: #fff;
				line-height: 60px;
				z-index: 1000;
				width: 200px;
				border-radius: 5px;
				-webkit-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
				/*no*/
				-moz-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
				/*no*/
				box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
				/*no*/
				padding: 0px 20px;

				li {

					border-bottom: 1px solid #f0f0f0;
					/*no*/
					position: relative;

					.queryIcon {
						position: absolute;
						right: 0;
						top: 50%;
						transform: translateY(-50%);
						width: 20px;

					}

					img {
						width: 20px;
						padding-right: 20px;
					}

					.queryIcon {
						position: absolute;
						top: 50%;
						right: 16px;
						transform: translateY(-50%);
					}
				}

				.active_color {
					color: #ff4081;
					border-bottom: 4px solid #f0f0f0;
					/*no*/
				}
			}
		}
	}

	// 系列
	.biaoqianTitle {
		position: relative;
		background-color: #fff;
		padding: 0 16px;

		h4 {
			color: #ff4081;
			padding: 20px 0;
			line-height: 40px;
			font-size: 36px;
			/*px*/
		}

		img {
			position: absolute;
			top: 50%;
			right: 10px;
			transform: translateY(-50%);
			width: 50px;
		}
	}

	//列表
	.checkedBooklist {
		overflow: hidden;
		padding: 0 16px;
		background-color: #fff;

		.checkedBook {
			float: left;
			width: 24%;
			padding-right: 8px;
			margin-bottom: 10px;

			.bookNameImg {
				position: relative;
				width: 180px;
				height: 270px;
				img {
					width: 180px;
					height: 270px;
					display: block;
				}

				.input_check {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					position: absolute;
					bottom: 0;
					left: 0;
					background-color: #fff;

					input[type="checkbox"] {
						width: 40px;
						height: 40px;
						border-radius: 50%;
						border: 1px solid #a5b7c0;
						/*no*/
					}

					input.active {
						background-color: #ff4081;
						border-color: #ff4081;
					}

					.icon {
						text-align: center;
						color: #fff;
						width: 35px;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}

			p {
				padding-top: 10px;
				font-size: 24px;
				/*px*/
				white-space: nowrap;
				overflow: hidden;
			}

		}

		.checkedBook:nth-child(4n) {
			padding-right: 0;
		}
	}

	.soltPhItemBox {
		padding: 0 16px;
		background-color: #fff;
	}

	.soltPhItemBox:last-child {
		border-bottom: 0;
	}

	.soltBox {
		padding-top: 60px;
		background-color: #fff;
	}

	// 云锦金榜 -- 封面模式
	.yunjin_jbBox {
		// height: 320px;
		border-bottom: 1px solid #f0f0f0;
		/*no*/
		padding: 20px 0px;
		padding-top: 0;

		.limiteFooter {
			display: flex;
			justify-content: space-between;
			background-color: #fff;
			line-height: 80px;
			position: relative;

			.btnLimite {
				font-size: 30px;
				/*px*/
				color: #ff4081;
				font-weight: 700;
				// transform: scale(1.1);
			}

			.limiteArr {
				img {
					width: 50px;
					position: absolute;
					top: 50%;
					right: 0;
					transform: translateY(-50%);
				}
			}
		}

		.yunjin_jb {
			margin-top: 10px;

			.swiper-container {
				height: 100%;

				.swiper-slide {
					width: 24% !important;
					margin-right: 8px !important;
					.checkedBook {
						.bookNameImg {
							position: relative;
							img {
								
								width: 155px;
								height: 240px;/*px*/
								-webkit-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								-moz-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								display: block;
							}

							.input_check {
								width: 40px;
								height: 40px;
								border-radius: 50%;
								position: absolute;
								bottom: 0;
								left: 0;
								background-color: #fff;

								input[type="checkbox"] {
									width: 40px;
									height: 40px;
									border-radius: 50%;
									border: 1px solid #a5b7c0;
									/*no*/
								}

								input.active {
									background-color: #ff4081;
									border-color: #ff4081;
								}

								.icon {
									text-align: center;
									color: #fff;
									width: 35px;
									position: absolute;
									top: 50%;
									left: 50%;
									transform: translate(-50%, -50%);
								}
							}
						}

						p {
							padding-top: 10px;
							font-size: 24px;
							/*px*/
							white-space: nowrap;
							overflow: hidden;
						}

					}

					.checkedBook:nth-child(4n) {
						padding-right: 0;
					}

					.bookImg {
						position: relative;

						.bookState {
							position: absolute;
							top: 10px;
							right: 6%;
							// border-top-left-radius: 30px;
							// border-bottom-left-radius: 30px;
							padding-left: 15px;
							padding-right: 10px;
							font-size: 22px;
							/*px*/
							color: #fff;
						}
					}

					.bookName {
						font-size: 22px;
						/*px*/
						overflow: hidden;
						white-space: nowrap;
						// text-overflow: ellipsis;
						padding-top: 10px;
						color: #3d3d3d;
						text-align: center;
					}

					.jianjie {
						font-size: 22px;
						/*px*/
						color: #a3a3a3;
						padding-top: 5px;
					}
				}
			}
		}
	}

	//列表模式
	.blockBox {
		overflow: hidden;
		// position: relative;
		background-color: #fff;
		padding: 0px 16px;

		// 系列
		.biaoqianTitle {
			position: relative;
			background-color: #fff;
			padding: 0 16px;

			h4 {
				color: #ff4081;
				padding: 20px 0;
				line-height: 40px;
				font-size: 30px;
				/*px*/
			}

			img {
				position: absolute;
				top: 50%;
				right: 10px;
				transform: translateY(-50%);
				width: 50px;
			}
		}

		.blockLeft {
			display: flex;
			background-color: #fff;
			padding: 20px 0px;
			padding-bottom: 20px;
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			.book_Img {
				// width: 138px;
				height: 270px;
				position: relative;

				img {
					height: 270px;
					display: block;
					float: left;
					-webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .3);
					/*no*/
					-moz-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .3);
					/*no*/
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, .3);
					/*no*/
				}

				.input_check {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					position: absolute;
					bottom: 0;
					left: 0;
					background-color: #fff;

					input[type="checkbox"] {
						width: 40px;
						height: 40px;
						border-radius: 50%;
						border: 1px solid #a5b7c0;
						/*no*/
					}

					input.active {
						background-color: #ff4081;
						border-color: #ff4081;
					}

					.icon {
						text-align: center;
						color: #fff;
						width: 35px;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}

				// 			img {
				// 				height: 270px;
				// 				display: block;
				// 				float: left;
				// 				-webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .3);
				// 				/*no*/
				// 				-moz-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .3);
				// 				/*no*/
				// 				box-shadow: 0 0 4px 0 rgba(0, 0, 0, .3);
				// 				/*no*/
				// 			}
			}

			.blockBookInfo {
				margin-left: 10px;
				flex: 1;
				font-size: 26px;
				/*px*/
				line-height: 30px;

				.auther {
					font-size: 28px;
					/*px*/
					color: #000;
					opacity: 0.6;
					position: relative;
					display: flex;
					justify-content: space-between;
					align-items: center;
					
					p {
						display: inline-block;
						float: right;
							
						span {
							margin-left: 8px;
							color: #000;
							opacity: 0.6;
							font-size: 26px;
							/*px*/
						}
					}
						
				}
						
				.bookName {
					// line-height: 40px;
					padding-bottom: 20px;
					font-size: 30px;
					/*px*/
					color: #000000;
					// font-weight: bold;
					height: 30px;
					.name{
						font-size: 30px;/*px*/
						color: #000000;
					}
					.bookTxtBox{
						display: inline-block;
						width: 300px;
						height: 30px;
						overflow: hidden;
						overflow-x: scroll;
						span{
							display: inline-block;
						}
					}
					
				}
						
				.auther {
					color: #000;
					opacity: 0.6;
					font-size: 26px;
					/*px*/
				}
						
				.bookType,
				.introduction {
					padding-top: 10px;
					color: #000;
					opacity: 0.4;
					font-size: 24px;
					/*px*/
				}

				.introduction {
					width: 60vw;
					padding-top: 15px;

					p {
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
				}

				.book_button {
					margin-top: 15px;

					button {
						outline: none;
						border: 0;
						border: 1px solid #fec6d5;
						/*no*/
						border-radius: 28px;
						padding: 0px 20px;
						display: inline-block;
						// line-height: 40px;
						background-color: #fff8fa;
						color: #fa7298;
						margin-right: 20px;
						font-size: 22px;
						/*px*/
						margin-bottom: 10px;
					}

					.active {
						background-color: #fa7298;
						color: #ffffff;
					}
				}
			}
		}

	}

	//底部
	.footer {
		position: fixed;
		bottom: 0;
		width: 100vw;
		display: flex;
		border-top: 1px solid #e5e5e5;

		/*no*/
		button {
			flex: 1;
			padding: 30px 0;
			background-color: #fff;
			border: 0;
			color: #3e3e3e;
			font-size: 34px;
			/*px*/
		}

		button.active {
			background-color: #ff4081;
			color: #ffffff;
		}
	}
</style>
